import React, { useState, useEffect } from "react";
import "../css/TeeStyles.css";
import { useLocation, Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Logo from "../icons/logo.png";

const Navbar: React.FC = () => {
  const [prevScrollPos, SetPrevScrollPos] = useState(window.pageXOffset);
  const [mobileNavToggle, setMobileNavToggle] = useState(true);
  const [buttonColor, setButtonColor] = useState<string>("black");

  const navBtnToggle = () => {
    setMobileNavToggle(!mobileNavToggle);
  };

  // Function to determine if background is dark
  const isBackgroundDark = (element: Element): boolean => {
    const bgColor = window.getComputedStyle(element).backgroundColor;
    const rgbValues = bgColor.match(/\d+/g); // Extract RGB values

    if (rgbValues) {
      // Calculate brightness
      const brightness = Math.round(
        (parseInt(rgbValues[0]) * 299 +
          parseInt(rgbValues[1]) * 587 +
          parseInt(rgbValues[2]) * 114) /
          1000
      );
      return brightness < 128; // Less than 128 means it's dark
    }
    return false;
  };

  // Scroll handler to change button color
  const handleScroll = () => {
    const sections = document.querySelectorAll(".section");

    sections.forEach((section) => {
      const sectionTop = section.getBoundingClientRect().top;
      const sectionBottom = section.getBoundingClientRect().bottom;

      // Check if section is in view
      if (
        sectionTop <= window.innerHeight / 2 &&
        sectionBottom >= window.innerHeight / 2
      ) {
        // If background is dark, set button color to white, else black
        if (isBackgroundDark(section)) {
          setButtonColor("white");
        } else {
          setButtonColor("black");
        }
      }
    });
  };

  useEffect(() => {
    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navButtonToggle = () => {
    setMobileNavToggle(!mobileNavToggle);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const navbar: any = document.querySelector(".navbar");
      const navbarM: any = document.querySelector(".navbarM");

      if (prevScrollPos > currentScrollPos) {
        navbar.style.padding = "10px";
        navbar.style.width = "100%";
        navbarM.style.padding = "12px";
      } else {
        navbar.style.padding = "20px";
        navbar.style.width = "90%";
        navbarM.style.padding = "6px";
      }

      SetPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;
  // console.log(pathname);

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");

  return (
    <>
      <nav className="boldNine  navbar fixed-top mx-auto px-4 wid100 contain forntSize14 centerText d-md-flex d-none justify-content-between align-items-center">
        <Link to={"/"}>
          <img src={Logo} alt="navicon" />
        </Link>
        <div className="d-flex wid25 rounded-4 widHalfMobileTwo py-2 px-3 justify-content-around bg-dark-transparent">
          <Link
            to={"/services"}
            className={
              splitLocation[1] === "services"
                ? "white me-2 boldSeven fontSize14px"
                : "white boldSeven fontSize14px"
            }
          >
            SERVICES
          </Link>
          <Link
            to={"/about"}
            className={
              splitLocation[1] === "about"
                ? "white boldSeven fontSize14px"
                : "white boldSeven fontSize14px"
            }
          >
            ABOUT US
          </Link>
          <Link
            to={"/"}
            className={
              splitLocation[1] === "contact"
                ? "white boldSeven fontSize14px"
                : "white boldSeven fontSize14px"
            }
          >
            CONTACT
          </Link>
        </div>
        <Link
          to={"/bookings"}
          style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
          className="fontSize10px rounded-4 p-2"
        >
          Book a session
        </Link>
      </nav>
      <nav
        className="boldNine navbarM fixed-top px-3 wid100 contain forntSize14 centerText bgWhiteBlur d-md-none d-flex justify-content-between align-items-center"
        style={{ padding: "12px" }}
      >
        <Link to={"/"} className="">
          <img src={Logo} alt="navicon" className="" />
        </Link>
        <div className=" justify-content-end">
          <div
            className={`${mobileNavToggle ? "" : "change"} barContainer`}
            onClick={navBtnToggle}
          >
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
          </div>
        </div>
      </nav>
      {!mobileNavToggle && (
        <div
          className=" wid100 mt-5 higt100 position-fixed d-flex"
          style={{ top: "1%", zIndex: 12, border: "solid 1px #111111" }}
        >
          <div className="wid40 bgWhiteBlur"></div>
          <div className="wid60 bg-nav-mobile-nav-dark px-3">
            <Link
              to={"/"}
              className={
                splitLocation[1] === ""
                  ? "white bg-nav-mobile-nav-blue py-2 d-flex align-items-center justify-content-center px-3 wid100 rounded-5 boldFive mt-6 fontSize20px boldSeven"
                  : "white py-1 d-flex align-items-center justify-content-center px-3 wid100 rounded-5 boldFive mt-6 fontSize20px boldSeven"
              }
            >
              <Icon icon="ion:home" className="fontSize20px me-3" />
              HOME
            </Link>
            <Link
              to={"/about"}
              className={
                splitLocation[1] === "about"
                  ? "white bg-nav-mobile-nav-blue py-2 d-flex align-items-center justify-content-center px-3 wid100 rounded-5 boldFive mt-2 fontSize20px boldSeven"
                  : "white py-1 d-flex align-items-center justify-content-center px-3 wid100 rounded-5 boldFive mt-2 fontSize20px boldSeven"
              }
            >
              <Icon
                icon="noto:globe-showing-europe-africa"
                className="fontSize20px me-3"
              />
              ABOUT US
            </Link>
            <Link
              to={"/services"}
              className={
                splitLocation[1] === "services"
                  ? "white bg-nav-mobile-nav-blue py-2 d-flex align-items-center justify-content-center px-3 wid100 rounded-5 boldFive mt-2 fontSize20px boldSeven"
                  : "white py-1 d-flex align-items-center justify-content-center px-3 wid100 rounded-5 boldFive mt-2 fontSize20px boldSeven"
              }
            >
              <Icon
                icon="fluent:people-20-filled"
                className="fontSize20px  me-3"
              />
              SERVICES
            </Link>
            <Link
              to={"/bookings"}
              className={
                splitLocation[1] === "bookings"
                  ? "white bg-nav-mobile-nav-blue py-2 d-flex align-items-center justify-content-center px-3 wid100 rounded-5 boldFive mt-6 fontSize20px boldSeven"
                  : "white py-1 d-flex align-items-center justify-content-center px-3 wid100 rounded-5 mt-6 boldFive mt-6 fontSize20px boldSeven"
              }
            >
              <Icon icon="clarity:note-line" className="fontSize34px  me-3" />
              Book a Session
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
